function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M129.116 56.563c-2.58-10.463-10.367-18.42-20.233-22.11a2.225 2.225 0 01-1.391-2.657c.03-.112.059-.225.087-.337 3.448-13.675-4.42-27.36-17.573-30.566C80.066-1.53 68.68.91 62.844 9.036c-3.038 4.23-7.56 3.978-12.72 2.94-5.884-1.183-13.85-1.485-20.077 0C7.493 17.354-4.117 44.102 1.331 66.2S28.34 95.133 52.034 96.475c4.497 0 6.739-.764 10.05-2.602 4.326-2.401 10.144-2.072 14.522.42 7.537 4.29 17.104 3.965 26.489 1.727 18.647-4.446 30.297-22.111 26.021-39.457z",
  fill: "#F2F2F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.167 27.95l-.287.825 18.5 6.232.287-.825-18.5-6.232z",
  fill: "#ECF3FE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.834 39.736l-6.24 17.939c-.186.533-.78.82-1.32.64a1.024 1.024 0 01-.646-1.302l6.24-17.939c.185-.533.78-.82 1.32-.639.54.182.83.767.645 1.301z",
  fill: "#F4B545"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.604 46.605l-4.286 12.322c-.186.533-.78.82-1.32.639a1.024 1.024 0 01-.646-1.302l4.286-12.321c.186-.533.78-.821 1.32-.64.542.183.832.769.646 1.302zM95.882 33.094l-9.925 28.523.743.25 9.925-28.522-.743-.251zM91.088 55.357l-.564 1.619 4.896 1.647.564-1.618-4.896-1.648zM92.655 50.854l-.797 2.288 4.896 1.647.797-2.288-4.896-1.647zM91.458 54.293l-.282.81 4.897 1.648.282-.81-4.897-1.648zM91.742 53.477l-.205.588 4.896 1.65.205-.59-4.897-1.648zM93.55 48.282l-.564 1.618 4.895 1.648.564-1.619-4.896-1.647zM93.92 47.217l-.282.81 4.896 1.648.282-.81-4.896-1.648zM95.334 43.154l-.797 2.287 4.896 1.648.797-2.288-4.896-1.648zM96.228 40.582l-.564 1.62 4.896 1.647.564-1.619-4.896-1.648zM96.598 39.516l-.282.81 4.897 1.649.282-.81-4.897-1.649zM94.202 46.402l-.205.588 4.897 1.649.204-.589-4.896-1.648z",
  fill: "#ECF3FE"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.85 84.47l-28.298-9.414c-1.653-.55-2.519-2.353-1.925-4.008l14.868-41.36c.594-1.655 2.433-2.558 4.086-2.009l28.299 9.414c1.653.55 2.519 2.353 1.924 4.008l-14.868 41.36c-.594 1.656-2.433 2.559-4.086 2.01z",
  fill: "url(#paint0_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.096 45.482c-4.608-1.532-9.706.973-11.364 5.583-1.657 4.612.743 9.61 5.35 11.143 4.609 1.532 9.707-.973 11.365-5.584 1.658-4.611-.742-9.61-5.351-11.142zm5.327 8.641c-.276-.822-.799-1.64-1.519-2.398-.042-1.566-.445-2.991-1.156-4.107a8.093 8.093 0 012.675 6.505zm-2.126 1.505c.126-.378.234-.756.32-1.132.831.643 1.306 1.238 1.355 1.69l-1.675-.558zm-.502-.167l-2.191-.728c.205-.594.381-1.178.527-1.747.782.387 1.46.784 2.02 1.17-.09.432-.209.869-.356 1.305zm-2.693-.895l-2.672-.889.695-1.931a26.22 26.22 0 012.516 1.005 20.62 20.62 0 01-.539 1.815zm-1.796-3.322l.702-1.953c.742.262 1.437.578 2.072.934a16.69 16.69 0 01-.316 1.997 27.165 27.165 0 00-2.458-.978zm.882-2.455l.967-2.69c.726.456 1.05 1.783.967 3.542-.6-.322-1.247-.61-1.934-.852zm-.501-.167a13.862 13.862 0 00-2.069-.478c1.065-1.434 2.172-2.284 3.036-2.211l-.967 2.69zm-.181.502l-.702 1.953a27.2 27.2 0 00-2.562-.69c.329-.64.677-1.231 1.034-1.76.729.097 1.477.262 2.23.497zm-.883 2.454l-.694 1.932-2.672-.888c.228-.61.477-1.194.742-1.748.821.174 1.702.407 2.624.704zm-3.867.877l-2.192-.729c.166-.43.353-.844.56-1.238.687.029 1.475.12 2.339.28a22.55 22.55 0 00-.707 1.687zm-2.693-.895l-1.675-.558c.329-.326 1.084-.512 2.15-.524-.173.348-.332.709-.475 1.082zm-1.855-.056l1.675.558a12.18 12.18 0 00-.32 1.133c-.832-.644-1.307-1.24-1.355-1.69zm2.176.724l2.192.729a22.051 22.051 0 00-.527 1.746 16.399 16.399 0 01-2.02-1.169c.09-.432.209-.869.355-1.306zm2.693.896l2.672.888-.695 1.932a26.167 26.167 0 01-2.516-1.005 21.26 21.26 0 01.54-1.815zm1.797 3.322l-.702 1.953a13.316 13.316 0 01-2.072-.935c.058-.627.163-1.298.316-1.997.785.36 1.617.69 2.458.98zM97.99 58.9l-.967 2.69c-.726-.456-1.05-1.783-.967-3.543.6.324 1.248.61 1.934.853zm.501.167c.696.217 1.39.376 2.069.478-1.065 1.434-2.172 2.284-3.036 2.211l.967-2.69zm.181-.501l.702-1.953a27.16 27.16 0 002.562.69c-.329.64-.677 1.232-1.034 1.76a13.518 13.518 0 01-2.23-.497zm.882-2.455l.695-1.932 2.672.888c-.227.61-.477 1.194-.742 1.748a26.18 26.18 0 01-2.625-.704zm3.868-.877l2.192.73c-.165.43-.353.844-.559 1.237a16.869 16.869 0 01-2.34-.28c.251-.534.488-1.097.707-1.687zm2.694.896l1.675.557c-.329.327-1.084.513-2.15.525.173-.348.331-.71.475-1.082zm.62-2.224c.083-.474.137-.944.159-1.404.721.873 1.154 1.805 1.217 2.703-.309-.428-.783-.867-1.376-1.299zm-.481-.332a18.166 18.166 0 00-1.996-1.117c.153-.672.262-1.319.329-1.93.682.428 1.285.902 1.789 1.406.003.533-.036 1.082-.122 1.641zm-1.616-3.638c.086-1.297-.035-2.4-.36-3.195 1.179.968 1.901 2.57 2.063 4.44-.5-.447-1.071-.866-1.703-1.245zm-5.618-1.869a11.762 11.762 0 00-2.139-.032c1.329-1.375 2.925-2.205 4.474-2.266-.765.431-1.57 1.227-2.335 2.298zm-.34.496c-.34.52-.668 1.094-.98 1.713-.8-.154-1.575-.26-2.287-.307.29-.49.612-.946.958-1.363.72-.096 1.498-.112 2.31-.043zm-3.86 1.381c-.743-.013-1.398.05-1.916.205.626-.67 1.565-1.145 2.693-1.403-.278.374-.537.776-.776 1.198zm-1.38 3.84c-.083.473-.137.942-.159 1.402-.72-.873-1.153-1.804-1.216-2.703.308.43.783.869 1.376 1.3zm.482.331c.59.387 1.267.763 1.996 1.118a17.103 17.103 0 00-.329 1.929 10.273 10.273 0 01-1.79-1.405c-.003-.533.037-1.083.123-1.642zm1.615 3.638c-.086 1.298.036 2.401.36 3.195-1.178-.968-1.9-2.57-2.063-4.44.5.447 1.071.866 1.703 1.245zm5.619 1.87c.741.077 1.459.086 2.139.032-1.329 1.375-2.926 2.205-4.474 2.265.765-.431 1.57-1.227 2.335-2.298zm.339-.496a17.7 17.7 0 00.981-1.713c.8.155 1.575.26 2.287.307-.291.49-.613.947-.958 1.364-.72.095-1.499.11-2.31.042zm3.86-1.382c.743.013 1.398-.05 1.916-.204-.626.67-1.565 1.145-2.692 1.403.278-.375.537-.776.776-1.199zm-5.718-12.158c-1.275.455-2.508 1.336-3.547 2.543-1.053.17-1.99.502-2.735.984a8.65 8.65 0 016.282-3.527zm-7.883 7.979c.276.822.799 1.64 1.52 2.398.04 1.566.444 2.992 1.155 4.107a8.091 8.091 0 01-2.675-6.505zm8.785 8.537c1.275-.455 2.508-1.337 3.547-2.543 1.053-.17 1.989-.502 2.735-.984a8.654 8.654 0 01-6.282 3.527zM98.874 34.755l.384.127-.998 2.759-.384-.127.998-2.759zm-.28 1.386l.875.29a.427.427 0 00.446-.106.62.62 0 00.141-.231.603.603 0 00.039-.268.401.401 0 00-.085-.216.411.411 0 00-.197-.132l-.875-.29.133-.368.862.285a.882.882 0 01.393.249.738.738 0 01.181.392c.022.15.003.31-.058.478a1 1 0 01-.262.41.8.8 0 01-.396.199.927.927 0 01-.469-.038l-.861-.286.133-.368zM101.879 35.757l.328.108.012 3.094-.414-.137.045-2.478-1.563 1.975-.414-.137 2.006-2.425zm-1.189 1.605l1.44.477-.132.369-1.441-.477.133-.369zM103.225 39.336l-.163-.096a1.42 1.42 0 01-.508-.509l.346-.217c.071.126.161.232.271.32.109.087.236.155.384.203.198.066.365.08.501.042a.392.392 0 00.277-.26l.001-.002a.344.344 0 00.008-.254.447.447 0 00-.147-.188 2.142 2.142 0 00-.299-.188l-.027-.015a2.895 2.895 0 01-.408-.256.639.639 0 01-.216-.315c-.043-.133-.03-.297.041-.492v-.002a.875.875 0 01.272-.4.786.786 0 01.432-.165c.168-.015.355.011.559.079a1.38 1.38 0 01.523.316c.077.074.148.157.214.25l-.329.236a1.271 1.271 0 00-.249-.277.91.91 0 00-.29-.16c-.187-.063-.346-.073-.477-.032a.411.411 0 00-.271.268v.002a.324.324 0 00-.001.25.496.496 0 00.156.187c.07.052.172.116.303.19l.013.008a1.531 1.531 0 01.032.019l.02.01c.153.09.276.175.371.26a.66.66 0 01.196.318c.037.129.023.284-.042.465l-.001.004a.834.834 0 01-.275.392.812.812 0 01-.442.16 1.489 1.489 0 01-.577-.086 85.492 85.492 0 01-.198-.065zM105.632 40.144l-.163-.096a1.456 1.456 0 01-.29-.224 1.466 1.466 0 01-.218-.285l.346-.217c.071.125.161.232.27.32.109.086.237.154.384.203.198.066.365.08.502.042a.395.395 0 00.277-.26v-.002a.35.35 0 00.009-.254.456.456 0 00-.147-.189 2.225 2.225 0 00-.3-.187l-.026-.016a2.974 2.974 0 01-.409-.255.637.637 0 01-.215-.316c-.043-.133-.03-.296.04-.49l.001-.003a.881.881 0 01.271-.4.79.79 0 01.433-.166c.168-.015.354.012.559.08a1.371 1.371 0 01.523.316c.077.073.148.156.214.25l-.329.236a1.324 1.324 0 00-.249-.277.914.914 0 00-.291-.161c-.187-.062-.345-.072-.476-.031a.409.409 0 00-.271.268l-.001.002a.319.319 0 000 .25.483.483 0 00.155.187 3.155 3.155 0 00.329.205l.02.011c.007.004.013.008.019.01.153.09.277.176.371.26.094.084.16.19.197.319.037.128.023.284-.042.465l-.002.003a.832.832 0 01-.274.393.815.815 0 01-.443.16 1.491 1.491 0 01-.577-.087l-.197-.064zM108.42 37.958l.384.128-.996 2.758-.384-.127.996-2.759zm-.28 1.386l.875.29a.428.428 0 00.446-.105.628.628 0 00.141-.232.617.617 0 00.039-.267.403.403 0 00-.282-.348l-.875-.29.133-.369.861.286a.883.883 0 01.393.248.74.74 0 01.182.393c.022.15.003.31-.058.478a.999.999 0 01-.262.41.798.798 0 01-.396.199.924.924 0 01-.468-.039l-.862-.285.133-.369zM110.256 41.555a.875.875 0 01-.209-.468 1.21 1.21 0 01.074-.574l.282-.781a1.25 1.25 0 01.312-.495.943.943 0 01.466-.244c.176-.036.359-.023.55.04.191.063.344.161.458.294a.873.873 0 01.209.468c.024.18 0 .372-.074.574l-.282.781a1.25 1.25 0 01-.312.495.947.947 0 01-.466.245 1.056 1.056 0 01-.549-.041 1.023 1.023 0 01-.459-.294zm.922-.066a.566.566 0 00.278-.152.792.792 0 00.189-.304l.292-.808a.771.771 0 00.047-.35.529.529 0 00-.12-.285.59.59 0 00-.271-.176.609.609 0 00-.325-.022.557.557 0 00-.278.152.768.768 0 00-.189.304l-.292.808a.746.746 0 00-.047.35c.012.11.053.205.12.285.067.08.158.138.27.175a.603.603 0 00.326.023zM113.339 39.607l.383.127-.996 2.76-.384-.128.997-2.76zm-.275 1.28l.932.31a.384.384 0 00.213.01.385.385 0 00.185-.107.577.577 0 00.127-.21.547.547 0 00.035-.24.356.356 0 00-.075-.194.37.37 0 00-.176-.117l-.933-.309.133-.368.918.304a.876.876 0 01.381.237c.096.105.155.23.177.372a.909.909 0 01-.052.451.94.94 0 01-.251.385.767.767 0 01-.38.187.9.9 0 01-.45-.038l-.918-.305.134-.368zm.642.53l.414.04.216 1.57-.455-.15-.175-1.46zM115.506 40.338l1.929.64-.133.367-1.928-.639.132-.368zm.691.482l.384.127-.914 2.532-.383-.128.913-2.53z",
  fill: "#fff"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.813 71.605l-1.529 4.21 6.961 2.295 1.528-4.21-6.96-2.295z",
  fill: "#B3CEF6"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.128 73.411l-.2.56 7.001 2.335.201-.56-7.002-2.335z",
  fill: "#ECF3FE"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.527 75.19c-.156.433-.731.636-1.284.453-.552-.183-.874-.682-.717-1.116.157-.433.732-.636 1.285-.453.552.183.873.682.716 1.116z",
  fill: "#ECF3FE"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M105.473 87.397l-17.33 1.912a1.44 1.44 0 01-1.6-1.278l-3.375-33.44a1.47 1.47 0 011.31-1.599l17.331-1.912a1.436 1.436 0 011.599 1.277l3.375 33.44a1.472 1.472 0 01-1.31 1.6z",
  fill: "#fff"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.552 61.721l-.833-8.241-10.633 1.193.833 8.241 10.633-1.193z",
  fill: "#E7E7E7"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.087 61.569l-.537-5.652c.987-.006 1.859.6 2.209 1.494v.001a2.35 2.35 0 01.153.64l.083.876a2.343 2.343 0 01-.03.663 2.498 2.498 0 01-1.878 1.977zM94.234 55.844s2.95-.626 3.163.99c.213 1.616.688 2.23.588 2.634-.1.405-2.776 1.021-3.313.98-.537-.041-.438-4.604-.438-4.604z",
  fill: "#142246"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.462 59.214l-.835.099c-.354.041-.677-.266-.717-.685-.04-.418.218-.794.571-.836l.836-.098a.571.571 0 01.404.11.689.689 0 01.202.228.869.869 0 01-.023.897l-.005.008a.631.631 0 01-.06.075.592.592 0 01-.373.202z",
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.28,
  d: "M94.511 60.2l-1.216.143c-.854.1-1.639-.358-1.99-1.083l-.322.038a1.922 1.922 0 01-.185-.665l-.016-.162a1.983 1.983 0 01.056-.693l.32-.038a2.064 2.064 0 011.744-1.523l1.216-.143a1.953 1.953 0 012.167 1.749l.016.162a2.058 2.058 0 01-1.79 2.215z",
  fill: "#F2F2F2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.825 60.165l-1.528.18a1.953 1.953 0 01-1.99-1.083 1.964 1.964 0 01-.186-.665l-.015-.162c-.023-.238-.001-.472.056-.692a2.063 2.063 0 011.742-1.523l1.585-.187a1.955 1.955 0 011.69.709c.237.288.391.646.43 1.045l.015.161c.03.31-.014.614-.122.892a2.01 2.01 0 01-.17.354 2.06 2.06 0 01-1.507.97z",
  fill: "#fff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.12 61.037a.777.777 0 01-.871-.703l1.594-.19a.81.81 0 01-.034.319l-.001.001a.829.829 0 01-.688.573z",
  fill: "#fff"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.092 60.734a.48.48 0 01-.54-.435l.987-.118a.512.512 0 01-.447.553z",
  fill: "#F2F2F2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.398 56.061l-1.594.191a.828.828 0 01.723-.893.777.777 0 01.845.562l.005.02c.01.04.017.079.02.12z",
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.557 55.66a.513.513 0 00-.448.554l.987-.12a.48.48 0 00-.54-.434zM94.838 60.164l-1.53.18a1.953 1.953 0 01-1.222-.254c2.923.055 3.295-.478 3.225-1.16-.074-.735.816-1.01.816-1.01L96.449 59a2.058 2.058 0 01-1.611 1.165z",
  fill: "#F2F2F2"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.065 59.362l-.314.234-.916-.635-.016-.158 1.743.5.413-.049-.68.511-.23-.403z",
  fill: "#595959"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.343 59.473l-.196-.162-.253.03-.903-.42-.172-.08-.018-.19.264-.203.692-.536.254-.03.16-.204.355.05s-.026.018-.069.055l-.003.002a1.7 1.7 0 00-.453.551 1.03 1.03 0 00-.092.278.967.967 0 00.096.186c.176.269.461.435.597.502.05.025.078.037.078.037l-.337.134z",
  fill: "#A8C1EC"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.117 59.357l-.365.24-.928-.75-.007-.066 1.797.517.413-.049-.73.517-.18-.409z",
  fill: "#EEE"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.797 58.684l-.012-.128.772-.859.35.154.149-.444.757.337-.412.049-.003.002-1.601.889z",
  fill: "#595959"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.8 58.706l-.006-.064.764-.944.401.147.097-.438.81.331-.412.049-.004.002-1.65.917z",
  fill: "#EEE"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.74 59.125s.202-1.02.184-1.211a3.398 3.398 0 00-.19-.801c-.128-.367-.59-.888-.59-.888l-.214-.083a.66.66 0 00-.163-.105 3.04 3.04 0 01-.139-.013l-.175-.069c.005.012.017.04.034.075l-.156.07c.003.005.303.16.52.481.193.412.288.987.026 1.432-.475.81-.024 2.162-.024 2.162l.886-1.05z",
  fill: "#142246"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M105.499 87.405l-1.458.162-3.645-36.267 1.458-.162a1.43 1.43 0 011.591 1.275l3.356 33.394c.08.793-.502 1.51-1.302 1.598z",
  fill: "#E4E4E4"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.55 89.09l-1.456.161a1.433 1.433 0 01-1.59-1.277L83.146 54.58a1.466 1.466 0 011.303-1.596l1.456-.16L89.55 89.09z",
  fill: "#A8C1EC"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.671 62.619c.022.083.045.192.059.333.017.173-.011.304-.076.393a.377.377 0 01-.274.151.402.402 0 01-.303-.072c-.108-.082-.174-.227-.19-.398a.62.62 0 01-.002-.142l-.547.063-.017-.176 1.35-.152zm-.642.25a.586.586 0 00-.001.146c.021.21.137.328.326.307.18-.02.255-.157.236-.35a.707.707 0 00-.03-.163l-.531.06zM103.103 63.72c.115-.013.214-.027.305-.043l.015.156-.192.028.001.008c.136.03.229.126.241.246a.212.212 0 01-.001.05l-.168.02a.307.307 0 000-.061c-.012-.125-.117-.204-.253-.212a.52.52 0 00-.084 0l-.523.06-.018-.176.677-.076zM103.774 64.516c-.06.01-.114-.03-.121-.1a.11.11 0 01.1-.12.106.106 0 01.122.099c.007.066-.038.114-.101.121zm-1.278-.055l.983-.112.017.178-.982.111-.018-.177zM103.534 64.884l-.531.254a2.701 2.701 0 01-.243.106l.001.006c.083.014.167.032.258.055l.569.126.018.185-1.016-.27-.017-.17.943-.48.018.188zM102.702 66.418l.122-.028-.001-.006a.359.359 0 01-.175-.281c-.019-.197.111-.313.252-.33.237-.026.387.169.422.544l.02-.002c.081-.009.225-.048.205-.246a.468.468 0 00-.097-.245l.114-.054a.59.59 0 01.117.31c.029.297-.168.392-.364.415l-.366.042c-.085.01-.168.023-.234.042l-.015-.16zm.497-.083c-.014-.193-.071-.408-.261-.387-.115.014-.163.096-.154.187a.24.24 0 00.187.216.18.18 0 00.057.003l.171-.019zM104.033 66.907l-.282.032.025.254-.136.015-.025-.253-.528.06c-.122.013-.187.055-.178.154.004.047.014.08.022.101l-.132.023a.424.424 0 01-.04-.154.251.251 0 01.056-.2c.048-.056.133-.083.249-.097l.534-.06-.014-.151.135-.016.015.15.235-.025.064.167zM103.286 67.532c-.241.031-.325.195-.308.372a.62.62 0 00.078.264l-.125.044a.784.784 0 01-.092-.316c-.03-.3.151-.501.446-.534.296-.033.546.113.573.396.031.318-.242.434-.422.454-.036.004-.065.003-.084.003l-.066-.683zm.178.504c.113-.01.285-.079.265-.278-.017-.179-.19-.239-.316-.238l.051.516zM103.109 69.86a.879.879 0 01-.1-.35c-.037-.383.178-.697.625-.748.427-.048.745.206.786.626a.731.731 0 01-.03.329l-.147-.026a.657.657 0 00.03-.28c-.031-.318-.256-.506-.614-.465-.334.038-.53.253-.498.583.01.106.043.212.085.279l-.137.052zM103.143 70.596l.123-.028-.001-.006a.359.359 0 01-.175-.281c-.02-.197.11-.313.252-.33.237-.026.387.168.422.544l.02-.002c.08-.009.224-.048.205-.246a.477.477 0 00-.097-.245l.113-.054a.583.583 0 01.118.31c.029.297-.168.392-.364.415l-.367.042c-.084.01-.167.023-.233.042l-.016-.161zm.498-.083c-.015-.194-.071-.408-.261-.387-.115.013-.163.095-.154.186a.238.238 0 00.187.217c.018.004.04.005.057.003l.171-.019zM103.866 70.946c.115-.014.214-.026.305-.043l.015.155-.192.028.001.008c.136.03.23.127.241.247a.211.211 0 01-.001.05l-.168.019a.307.307 0 000-.06c-.012-.126-.116-.204-.253-.213a.508.508 0 00-.084.001l-.523.059-.017-.175.676-.076zM104.654 71.953c.026.104.051.23.065.368.024.251-.016.437-.116.568-.099.133-.251.22-.472.246-.222.025-.411-.022-.549-.135-.14-.112-.229-.313-.254-.576a2.977 2.977 0 01-.015-.32l1.341-.151zm-1.189.311c-.004.046.001.11.007.178.037.374.268.553.636.512.322-.035.509-.239.472-.609a.985.985 0 00-.038-.203l-1.077.123zM104.12 73.355c.116-.014.215-.026.306-.043l.015.155-.192.028v.009c.137.03.23.126.242.246a.211.211 0 01-.001.05l-.169.02a.3.3 0 00.001-.062c-.012-.124-.117-.203-.253-.212a.505.505 0 00-.084.002l-.523.059-.018-.175.676-.077zM104.792 74.15c-.06.01-.114-.029-.121-.1a.11.11 0 01.1-.12.106.106 0 01.122.1c.007.066-.038.114-.101.12zm-1.278-.054l.983-.112.017.178-.982.111-.018-.177zM104.553 74.519l-.532.253a2.608 2.608 0 01-.243.107l.001.006c.083.013.167.032.259.054l.569.127.018.185-1.017-.271-.016-.169.943-.48.018.188zM104.943 75.58c-.061.01-.114-.03-.121-.1a.11.11 0 01.1-.12.106.106 0 01.122.099c.006.067-.038.115-.101.121zm-1.278-.055l.983-.112.017.178-.983.112-.017-.178zM104.432 75.91a3.28 3.28 0 00.264-.038l.016.156-.161.028v.004c.098.038.2.14.215.3.014.135-.047.353-.383.391l-.584.066-.017-.176.564-.064c.158-.018.283-.091.267-.258a.247.247 0 00-.205-.216.25.25 0 00-.084-.003l-.588.067-.017-.177.713-.08zM104.897 77.826a3.965 3.965 0 00-.27.022l-.57.065c-.224.026-.367-.003-.461-.088a.506.506 0 01-.152-.341.628.628 0 01.049-.333l.14.029a.546.546 0 00-.049.294c.017.181.126.303.373.276l.11-.013-.001-.004a.342.342 0 01-.194-.291c-.023-.242.166-.438.437-.47.333-.037.542.157.564.38a.331.331 0 01-.141.324l.001.004.148-.01.016.156zm-.405-.139a.263.263 0 00.245-.288c-.016-.169-.172-.273-.399-.248-.193.022-.343.137-.325.328.011.109.09.2.206.225a.318.318 0 00.097.004l.176-.02zM105.364 78.494l.017.175-1.217.137.057.58-.148.017-.073-.754 1.364-.155zM105.372 79.643c-.06.01-.113-.03-.12-.1a.108.108 0 01.099-.12.106.106 0 01.122.099c.006.066-.038.114-.101.121zm-1.277-.055l.982-.112.017.178-.982.111-.017-.177zM104.252 80.743a.641.641 0 01-.084-.273c-.029-.293.153-.507.452-.541a.491.491 0 01.572.463c.01.105-.008.2-.027.25l-.142-.024a.42.42 0 00.027-.21c-.022-.223-.199-.325-.404-.302-.227.026-.352.187-.333.379.01.1.043.164.07.211l-.131.047zM104.708 80.984c-.241.032-.325.195-.308.372.013.127.042.2.077.264l-.124.044a.765.765 0 01-.093-.316c-.029-.3.152-.5.447-.534.296-.033.545.113.573.396.031.318-.242.434-.422.454-.036.004-.065.003-.084.003l-.066-.683zm.178.504c.113-.01.284-.079.265-.278-.017-.179-.191-.238-.316-.238l.051.516zM105.061 81.86c.101-.012.184-.023.264-.039l.015.157-.161.028v.004c.098.037.2.139.216.3.013.134-.047.352-.383.39l-.585.066-.017-.176.565-.064c.157-.018.283-.091.267-.257a.247.247 0 00-.205-.217.25.25 0 00-.084-.003l-.589.067-.017-.176.714-.08zM104.568 83.739a.641.641 0 01-.084-.273c-.029-.293.153-.507.452-.541a.491.491 0 01.572.463c.01.105-.008.2-.027.251l-.142-.024a.42.42 0 00.027-.211c-.022-.223-.199-.325-.404-.302-.227.026-.352.187-.333.38.01.1.043.163.07.21l-.131.047zM105.024 83.98c-.24.03-.324.194-.307.371.012.127.042.2.077.264l-.125.044a.784.784 0 01-.092-.316c-.029-.3.152-.5.447-.534.295-.033.545.113.573.396.031.318-.242.434-.422.454-.036.004-.065.003-.084.003l-.067-.683zm.178.503c.114-.01.285-.079.266-.278-.018-.178-.191-.238-.316-.238l.05.516z",
  fill: "#fff"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.908 73.459l-.92-9.144a.787.787 0 01.698-.854c.426-.047.81.26.852.684l.919 9.143a.787.787 0 01-.697.855.77.77 0 01-.852-.684zM97.297 85.82l-2.13-21.203a.787.787 0 01.697-.854.767.767 0 01.85.683l2.13 21.202a.787.787 0 01-.696.854.767.767 0 01-.85-.682zM93.72 79.11l-1.427-14.19a.787.787 0 01.698-.855.768.768 0 01.85.684l1.427 14.19a.787.787 0 01-.697.854.769.769 0 01-.851-.683zM91.231 82.963l-1.783-17.741a.787.787 0 01.697-.855.767.767 0 01.85.684l1.783 17.742a.787.787 0 01-.696.854.77.77 0 01-.851-.684z",
  fill: "#E7E7E7"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.795 95.338l-13.566-5.322a.86.86 0 01-.487-1.153l10.939-24.635c.199-.45.745-.668 1.213-.484l13.566 5.322c.467.183.685.7.485 1.15l-10.938 24.636a.956.956 0 01-1.212.486z",
  fill: "#fff"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.314 68.575l-3.234-1.26-11.743 26.281 3.233 1.26 11.744-26.281zM106.156 76.376l3.436-7.694-1.513-.59-3.436 7.694 1.513.59zM98.984 76.894l4.955-11.085-1.152-.45-4.954 11.086 1.151.45zM102.289 85.015l3.436-7.695-1.513-.59-3.436 7.695 1.513.59zM99.615 90.986l2.353-5.271-1.512-.59-2.352 5.27 1.511.59zM102.83 78.201l4.624-10.35-1.514-.59-4.624 10.35 1.514.59zM100.541 83.308l1.949-4.368-1.511-.59-1.949 4.369 1.511.59zM97.478 90.154l2.811-6.297-1.512-.59-2.81 6.297 1.511.59z",
  fill: "#E7E7E7"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.248 15.834H29.383v73.594h64.865V15.835z",
  fill: "#fff"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.912 20.095H31.786v65.231h60.126V20.095z",
  fill: "url(#paint1_linear)"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.615 40.433l.325 2.317H7.837c.97-.396.741-1.797.451-1.955-.164-.087-.435-.043-.702.142l-.387-2.756h2.1l.316 2.252z",
  fill: "#112B46"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.367 38.533l1.865-.031.531 3.756-1.852-.047-.544-3.678z",
  fill: "#F9FBFC"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.197 38.177l.386 2.756c-.11.075-.222.174-.319.3l-.419-2.827.352-.23z",
  fill: "#56548C"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.318 39.937c-.554 1.42-1.769 2.937-3.936 4.016-3.663 1.825-8.359 2.754-13.068 1.668a4.555 4.555 0 01-.01-.69 3.89 3.89 0 01.516-1.751c1.379.185 3.198.16 5.083-.622 3.89-1.615 9.15-7.088 10.78-6.568.931.297 1.379 2.039.635 3.947z",
  fill: "url(#paint2_linear)"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.314 45.62a17.81 17.81 0 01-3.398-1.15h-.003a19.071 19.071 0 01-2.01-1.07s-.206-1.145.139-1.826a1.67 1.67 0 01.222-.34c.097-.124.21-.226.319-.3.27-.183.538-.23.702-.143.29.158.519 1.56-.45 1.959H9.94l-.329-2.32c.805-.183.767 2.128.767 2.128s.97.43 2.441.622c-.174.29-.464.894-.515 1.75a4.54 4.54 0 00.01.69z",
  fill: "#FFC8AF"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.318 39.938c-.554 1.42-1.769 2.935-3.936 4.015-3.663 1.826-8.359 2.754-13.068 1.668a17.81 17.81 0 01-3.398-1.151 38.29 38.29 0 003.389.46c2.322.211 5.073.23 7.614-.336 4.28-.953 7.772-3.373 9.399-4.657z",
  fill: "#DB6500"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.912 42.546l.029.2H7.837c-.228.124.187.19.938.146a2.102 2.102 0 011.278.355l-.141-.701z",
  fill: "#F2A98F"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.164 60.938c-.11 1.278-.587 3.964-2.52 7.766-3.11 6.135-2.48 5.665.307 22.223-.448.2-1.643.6-3.656.325-.554-1.464-1.93-5.192-3.076-9.093-.818-2.788-1.52-5.662-1.717-7.874-.46-5.077 1.108-12.19 1.688-14.58 1.443.377 4.513 1.039 8.974 1.233z",
  fill: "url(#paint3_linear)"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.547 60.953a50.934 50.934 0 01-5.785-.53 34.915 34.915 0 01-3.572-.723c-.618-.16-.937-.275-.937-.275s-.957-18.922 3.43-23.436c1.62.13 2.87-.414 3.685-1.77 0 0 2.161 1.405 2.795 1.77.207.121.825 1.51 1.395 3.763 1.173 4.622 2.152 12.87-1.011 21.201z",
  fill: "url(#paint4_linear)"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.547 60.954c-.129-.003-.261-.01-.383-.016a50.958 50.958 0 01-5.402-.513c1.462-3.07 3.585-7.243 3.959-8.994.979-4.616-.062-7.97-1.74-10.967 0 0 3.492-1.665 3.627-1.708.032 0 .39.377.95.996 1.173 4.622 2.152 12.87-1.011 21.202z",
  fill: "#DB6500"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.685 30.85c.28.567.86 1.947 2.052 2.42.132.42.335.758.63.953-.814 1.355-2.064 1.903-3.684 1.77l-.705-1.266c-.351.282-.767.446-1.234.52 0 0-2.142-1.476-2.11-5.439.235-.022.467-.074.693-.142.332-.096.718-.217 1.005-.025.245.164.309.501.55.671.274.198.677.118.964.291.306.183.37.575.525.888.045.087.103.173.2.207.173.056.344-.12.366-.294.02-.173-.054-.343-.086-.513-.03-.17-.004-.38.15-.47.136-.075.313-.031.432.064.113.09.184.23.252.366z",
  fill: "#FFC8AF"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.295 91.252c2.013.275 3.212-.127 3.656-.325.106.656.222 1.34.338 2.051.068.396-.225.761-.64.804l-7.354.746c-.474.046-.686-.56-.28-.795l4.274-2.478h.006v-.003z",
  fill: "#112B46"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.634 29.802c-.2.022-.399.022-.602-.006-.431-.065-.853-.285-1.076-.647-.341-.56-.064-1.38.558-1.633.393-.164.863-.115 1.243-.31.316-.16.518-.464.766-.711.38-.375.928-.637 1.466-.542.319.056.615.23.937.251.377.022.738-.158 1.108-.201.577-.065 1.18.241 1.45.74.203.367.228.829.525 1.135.222.232.563.337.773.581.183.22.232.523.2.805-.03.281-.13.55-.21.823-.264.925-.332 2.243-.035 3.177-1.189-.47-1.772-1.853-2.052-2.42-.068-.135-.139-.275-.255-.37-.119-.096-.296-.14-.431-.066-.155.09-.18.3-.151.47.032.171.106.341.086.514-.019.174-.19.35-.367.294-.093-.03-.154-.12-.2-.207-.154-.313-.219-.702-.524-.888-.29-.173-.693-.093-.963-.29-.242-.17-.306-.508-.551-.672-.287-.192-.673-.071-1.005.025a3.076 3.076 0 01-.69.148z",
  fill: "#142246"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.19 59.701c-.576 2.392-2.148 9.504-1.688 14.581.2 2.212.902 5.09 1.717 7.874-.956 2.843-1.646 5.887-2.064 8.016-2.764.377-4.043-.442-4.043-.442 2.568-21.292 5.138-30.304 5.138-30.304s.322.114.94.275z",
  fill: "url(#paint5_linear)"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.158 90.172c-.171.863-.297 1.572-.377 2.064a.883.883 0 01-.883.727h-6.76c-.535 0-.722-.684-.255-.938l4.232-2.296c-.003 0 1.279.82 4.043.443z",
  fill: "#112B46"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.787 48.124c.094 4.396-1.088 8.418-6.693 11.747-1.098-.582-1.62-1.621-1.836-2.2 1.437-1.689 2.774-3.7 3.04-5.439.51-3.264.848-5.067-2.193-9.63-3.037-4.561-1.079-7.348 2.059-6.615 1.88 1.41 5.514 7.211 5.623 12.137z",
  fill: "url(#paint6_linear)"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.261 57.675c.216.578.738 1.618 1.836 2.2-.68.402-1.417.798-2.232 1.178 0 0 .149 1.16-.908 1.482-1.056.325-1.546.508-1.659 1.52-.112 1.014-.918 1.036-1.317.507-.4-.526-.654-2.367.95-3.608.744-.578 2.074-1.806 3.33-3.28z",
  fill: "#FFC8AF"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.977 34.724s.783-.585 1.012-.829l.225-.248s-.186.845-1.075 1.368l-.162-.29zM29.788 31.061c.183.369-.03.783-.245.9 0 0 .18.267.464.143.283-.124.058-.501.058-.501l-.277-.542zM29.102 31.2c-.036-.12-.139-.371.016-.467.122-.077.29.022.377.102.145.13.116.282.129.458.006.102-.016.217-.136.257-.087.028-.183-.003-.203-.093-.012-.059.033-.105.026-.164-.01-.124-.129-.108-.21-.093z",
  fill: "#F2A98F"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.763 73.514v11.813h37.632V73.514c0-6.474-3.984-11.952-9.475-13.788a12.699 12.699 0 00-2.038-.497 12.833 12.833 0 00-1.994-.157H56.267c-.66 0-1.31.051-1.946.15-.172.027-.344.058-.516.089h-.003c-.535.105-1.058.245-1.567.415-5.484 1.836-9.472 7.314-9.472 13.788z",
  fill: "#DCE7F8"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.202 50.995H51.686c-1.201 0-2.174-.934-2.174-2.088s.973-2.089 2.174-2.089h19.516c1.201 0 2.174.935 2.174 2.089.003 1.154-.973 2.088-2.174 2.088z",
  fill: "#EFBC90"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.525 41.185h3.894v2.506c0 .022 0 .047-.003.069h.003v2.506c0 1.676-1.427 3.047-3.172 3.047h-.722c-.502 0-.911-.393-.911-.876V42.061c-.004-.483.409-.876.911-.876zM57.5 34.493l2.925 6.692h-5.998c.503 0 .912.393.912.876V48.437c0 .483-.41.876-.912.876h-.721c-1.746 0-3.173-1.371-3.173-3.048V43.76h.003l-.003-.068v-2.506c0-3.697 3.118-6.692 6.967-6.692z",
  fill: "#142246"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.475 66.532c-3.124 0-5.653-2.431-5.653-5.43V46.445c0-3 2.532-5.43 5.653-5.43 3.124 0 5.653 2.432 5.653 5.43v14.659c.003 3-2.529 5.43-5.653 5.43z",
  fill: "#EFBC90"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.475 61.143c-5.105 0-9.248-3.976-9.248-8.882V44.52c0-4.904 4.14-8.882 9.248-8.882 5.105 0 9.247 3.975 9.247 8.882v7.74c0 4.907-4.139 8.883-9.247 8.883z",
  fill: "#F4CAAB"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.113 33.237c-.225-1.12.017-2.256.017-2.256 2.666 1.919 6.47 2.219 8.049 2.256h2.966c4.57 0 8.271 3.558 8.271 7.945H58.802c-4.57 0-8.272-3.558-8.272-7.945h2.583z",
  fill: "#142246"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.92 59.458a13.483 13.483 0 00-1.567-.386l-6.166 19.142-1.608 4.996-1.608-4.996-6.166-19.142c-.535.098-1.057.228-1.567.386-5.49 1.7-9.475 6.784-9.475 12.794V85.327h37.632V72.252c0-6.007-3.984-11.094-9.475-12.794z",
  fill: "url(#paint7_linear)"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.475 83.165l1.626-4.891 6.236-18.743c.541.096 1.07.223 1.585.378 5.553 1.664 9.582 6.642 9.582 12.523v12.803h-19.03v-2.07z",
  fill: "url(#paint8_linear)"
});

var _ref61 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 73.954,
  y1: 51.077,
  x2: 109.376,
  y2: 70.694,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#2C41BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#798FF4"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 50.536,
  y1: 86.902,
  x2: 90.081,
  y2: -6.23,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#80CCFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F2FAFF"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 29.381,
  y1: 36.374,
  x2: 20.466,
  y2: 30.405,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 34.493,
  y1: 68.714,
  x2: 29.074,
  y2: 69.383,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 37.455,
  y1: 35.324,
  x2: 28.466,
  y2: 33.684,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 25.838,
  y1: 68.209,
  x2: 22.727,
  y2: 68.433,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 40.628,
  y1: 36.862,
  x2: 33.946,
  y2: 35.863,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 79.723,
  y1: 60.157,
  x2: 58.439,
  y2: 48.263,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 80.164,
  y1: 60.593,
  x2: 67.126,
  y2: 56.83,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})));

var SvgCardPhotoIcon = function SvgCardPhotoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 130,
    height: 100,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCardPhotoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card-photo-icon.241b8814.svg";
export { ForwardRef as ReactComponent };